import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, MapPin, Phone, Clock, Mail } from "lucide-react";
import { company, serviceAreas } from "../mock";

const Footer = () => {
  return (
    <footer className="mh-footer">
      <div className="mh-container mh-footer-grid">
        <div className="mh-footer-brand">
          <h3 className="mh-footer-name">Monarch Homes<span>of Brevard</span></h3>
          <p>{company.tagline}. Proudly building beautiful, energy-efficient custom homes across Brevard County and the Space Coast since {company.founded}.</p>
          <div className="mh-social">
            <a href={company.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><Facebook size={18} /></a>
            <a href={company.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><Instagram size={18} /></a>
          </div>
        </div>

        <div className="mh-footer-col">
          <h4>Explore</h4>
          <ul>
            <li><Link to="/available-homes">Available Homes</Link></li>
            <li><Link to="/virtual-tours">Virtual Tours</Link></li>
            <li><Link to="/build-on-your-lot">Build On Your Lot</Link></li>
            <li><Link to="/remodel">Remodel</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/who-we-are">Who We Are</Link></li>
            <li><Link to="/partners">Partners</Link></li>
            <li><Link to="/testimonials">Testimonials</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/accessibility-statement">Accessibility Statement</Link></li>
          </ul>
        </div>

        <div className="mh-footer-col">
          <h4>Visit Us</h4>
          <ul className="mh-contact-list">
            <li><MapPin size={16} /><span>{company.address}<br />{company.cityStateZip}</span></li>
            <li><Phone size={16} /><a href={company.phoneHref}>{company.phone}</a></li>
            <li><Mail size={16} /><a href={`mailto:${company.email}`}>{company.email}</a></li>
            <li><Clock size={16} /><span>{company.hours}</span></li>
          </ul>
        </div>
      </div>

      <div className="mh-footer-areas">
        <div className="mh-container">
          <span>Custom Home Builder proudly serving Brevard County &amp; the Space Coast:</span>{" "}
          {serviceAreas.map((a, i) => (
            <React.Fragment key={a}>
              <span className="mh-footer-area">{a}</span>{i < serviceAreas.length - 1 ? " \u00b7 " : ""}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="mh-footer-bottom">
        <div className="mh-container mh-footer-bottom-inner">
          <span>{company.license} &nbsp;|&nbsp; &copy; {new Date().getFullYear()} {company.name}</span>
          <span className="mh-footer-credit">
            Website Designed By <a href="https://bp.agency" target="_blank" rel="noreferrer"><strong>Brand Partners</strong></a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
